import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08b55d1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    class: _ctx.getClasses.wrap
  }, _ctx.$attrs, {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.listener && _ctx.listener(...args)))
  }), [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClasses.body)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFormatOptions, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.value,
          class: _normalizeClass(item.itemClasses),
          onClick: ($event: any) => (_ctx.onTapByItem(item.value))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(item.txtClasses)
          }, _toDisplayString(item.label), 3)
        ], 10, _hoisted_1))
      }), 128))
    ], 2)
  ], 16))
}